<template>
  <a-modal title="清空课程内容" v-model="state.visible" @ok="confirm" @cancel="closeModal" :centered="true" width="80%">
    <div>
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="课程名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseName" placeholder="请输入课程名称" />
        </a-form-model-item>
        <a-form-model-item label="课程类型">
          <a-select class="serach-item" allowClear v-model="searchForm.courseType" placeholder="请选择课程类型">
            <a-select-option value="1">测评</a-select-option>
            <a-select-option value="2">训练</a-select-option>
            <a-select-option value="3">活动</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="学段">
          <a-select allowClear v-model="searchForm.periodList" placeholder="请选择" mode="multiple" style="min-width: 180px">
            <a-select-option :value="item" :key="item" v-for="item in $data._period">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="search(1)" type="primary" html-type="button"> 查询 </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-table
        style="min-width: 800px"
        :columns="columns"
        :scroll="{ y: 300 }"
        :rowKey="(text) => text.id"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :pagination="{
          showLessItems: true,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]} 至 ${range[1]} 条，总计 ${total} 条`,
          pageSizeOptions: ['10', '20', '50', '100', '500', '1000'],
        }"
        :dataSource="tableRelevant.tableDataSource"
        :row-selection="rowSelection"
      >
        <div slot="courseName" slot-scope="text">
          <span>{{ text.name }}{{ text.period ? ' - ' + text.period : '' }}</span>
        </div>
        <div slot="courseType" slot-scope="text">
          <span>{{ $data._courseType[text.courseType] }}</span>
        </div>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

export default {
  name: 'clearCourseContentRef',
  data() {
    return {
      searchForm: {
        courseType: undefined,
        courseName: undefined,
        periodList: [],
      },
      state: {
        visible: false,
        title: '清空课程',
      },
      tableRelevant: tableRelevant.call(this),
      tableSelectedRowKeys: [],
      options: {},
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.tableSelectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.tableSelectedRowKeys = selectedRowKeys
        },
      }
    },
    columns() {
      return [
        {
          title: '关联课程',
          scopedSlots: { customRender: 'courseName' },
        },
        {
          title: '学段',
          dataIndex: 'period',
        },

        {
          title: '课程类型',
          scopedSlots: { customRender: 'courseType' },
        },
        {
          title: '课时数',
          dataIndex: 'courseSessionCount',
        },
      ]
    },
  },
  methods: {
    showModal(options) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.state.visible = true
        this.options = options
        this.getPageList()
      })
    },
    getPageList(pageIndex) {
      let params = {
        courseSeriesId: this.options.seriesId,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }

      this.tableRelevant.tableLoading = true
      this.$http.CourseResource.courseList(params).then(({ data }) => {
        this.tableRelevant.tableDataSource = data.items
        this.tableData = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = params.pageIndex
        this.tableRelevant.tablePagination.pageSize = params.pageSize
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    closeModal(reject) {
      this.state.visible = false
      this.tableSelectedRowKeys = []
      this.searchForm = {
        courseType: undefined,
        courseName: undefined,
        periodList: [],
      }
      reject ? this._reject() : this._resolve()
    },
    async confirm() {
      if (!this.tableSelectedRowKeys.length) {
        return this.$message.error('请勾选内容')
      }
      this.$confirm({
        title: '确定清空所选课程的所有内容？',
        content: '清空后所正在使用的课程将受到影响，请谨慎操作',
        onOk: async () => {
          const params = {
            "courseIds": this.tableSelectedRowKeys,
          }
          await this.$http.CourseResource.contentDelete(params)
          this.$message.success('操作成功')
          this.closeModal()
        },
      })
    },
    search(pageIndex) {
      this.tableRelevant.tablePagination.current = 1
      this.tableRelevant.tableDataSource = this.tableData.filter((f) => {
        let bool = f.name.indexOf(this.searchForm.courseName || '') > -1
        if (this.searchForm.courseType) {
          bool = bool && this.searchForm.courseType == f.courseType
        }
        if (this.searchForm.periodList.length) {
          bool = bool && this.searchForm.periodList.includes(f.period)
        }
        return bool
      })
    },
  },
}
</script>
